



















import Vue from 'vue'
/**
 * This is considered to be a child of a form
 */
export default Vue.extend({
    name: 'GdprConsent',
    props: {
        valid: Boolean,
        pending: Boolean,
    },
    data() {
        return {
            agreed: false,
        }
    },
})
